/**
 * Reads environment configuration that must be resolvable at container start.
 *
 * CRA inlines `process.env.REACT_APP_*` into the bundle at build time, so a
 * single image cannot be promoted across environments that point at different
 * backends. `public/env-config.js` is regenerated from the container
 * environment on every start and loaded before the bundle, so values placed on
 * `window.__RUNTIME_CONFIG__` win over whatever was inlined.
 *
 * `process.env` remains the fallback so `npm start` and local `npm run build`
 * keep working from a plain `.env` with no extra setup.
 */

export interface RuntimeConfig {
  REACT_APP_API_BASE_URL?: string;
  REACT_APP_PORTAL_API_BASE_URL?: string;
  REACT_APP_UPLOAD_API_URL?: string;
}

declare global {
  interface Window {
    __RUNTIME_CONFIG__?: RuntimeConfig;
  }
}

export const getRuntimeEnv = (
  name: keyof RuntimeConfig,
): string | undefined => {
  if (typeof window !== 'undefined') {
    const value = window.__RUNTIME_CONFIG__?.[name];
    // The generated file ships every key, using an empty string for anything
    // the environment did not set, so blanks must not shadow process.env.
    if (typeof value === 'string' && value.trim() !== '') return value;
  }

  return process.env[name];
};
